import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Segment, Grid } from 'semantic-ui-react'
//@ts-ignore
import LKButton from 'shared/LKButton'
import { DocumentTitle, withConstantPermissions } from 'shared'
//@ts-ignore
import { SegmentGroup, FlexTableChild, TableContainer, GridContainer } from 'shared/StyledComponents'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
import { date as dateFormatter } from 'loankeeper-common/helpers/formatters'
import { translateCmd, translateBase, translateLKMessage, icon, translateWebMessages } from '../helpers'
import { constants as DCConstants, actions as DCActions } from '../../DetailsContainer'
import FileUpload, { open as openFileUpload } from '../../shared/FileUpload'
import { downloadRemote, openFileDetails } from '../../FileDetails'
import { deleteFile, toggleFileVisa, toggleDeleteFileVisa } from 'src/store/linkedFiles'
import { translate } from 'loankeeper-common/helpers'
import { actions as LKModalActions } from '../../shared/LKModal'

import { FileUploadMethodParams, FileUploadTabProps } from '../types'

const config = {
  gridIdentity: {
    formName: 'frm_client_view',
    objectName: 'dbgrd_files',
  },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableColumnsHide: true,
  enableSorting: true,
  enableRowSelection: true,

  getRowStyle: ({
    node: {
      data: { FActive },
    },
  }) => {
    if (FActive !== 1) {
      return { backgroundColor: 'gray' }
    }
  },

  columnConfigs: {
    ADate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    DocDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    FActive: {
      iconComponent: (value) => (value === 1 ? 'ok' : null),
    },

    ID: {
      cellStyle: { textAlign: 'right' },
    },
  },
}

@withRouter
//@ts-ignore
@withConstantPermissions(['LFL_ADD as CanAdd', 'LFL_VIEW as CanView', 'LFL_VISA as CanChangeVisa'])
//@ts-ignore
@connect(undefined, {
  openError: (message: string) => LKModalActions.openError(message),
  openFileUpload: (params: FileUploadMethodParams) =>  openFileUpload(params),
  openFileDetails,
  fetchPage: (ID, hash, callback) =>
    DCActions.fetchPage(
      {
        type: 'Client',
        ID,
        hash,
        page: 'linkedfiles',
      },
      callback,
    ),
  downloadRemote,
  deleteFile,
  toggleFileVisa,
  toggleDeleteFileVisa,
})
class Files extends React.Component<FileUploadTabProps> {
  viewFile = (ID, Hash, Ext) => {
    this.props.history.push(`/secure/file/${ID}/details/${Hash}/${Ext}`)
  }

  getContextMenuItems = ({ node: { data } }) => [
    ...(['jpg', 'pdf'].includes(data.Ext.toLowerCase())
      ? [
          {
            name: translateBase('cmd_preview_linkedfile'),
            action: () => {
              const { ID, HashSum_FileID_: hash, Ext } = data

              this.props.openFileDetails({
                ID,
                hash,
                type: Ext,
              })
            },
            icon: 'preview',
            permissionKey: 'LFL_VIEW',
          },
        ]
      : []),

    {
      name: translateWebMessages('cmd_lfl_download'),
      action: () => {
        const { ID, HashSum_FileID_: hash, Ext } = data

        this.props.downloadRemote({ ID, hash, extension: Ext })
      },
      icon: 'download',
      permissionKey: 'LFL_VIEW',
    },

    {
      name: translateBase('cmd_edit_linkedfile'),
      action: () => {
        const { ID, HashSum_FileID_, FActive, Title, Title_ALT, TypeID } = data
        this.props.openFileUpload({
          ClientID: this.props.ID,
          HashSum_ClientID_: this.props.hash,
          ID,
          HashSum_FileID_,
          FActive,
          Title,
          Title_ALT,
          TypeID,
        })
      },
      icon: 'edit',
      permissionKey: 'LFL_EDIT',
    },

    {
      name:
        data.VisaLoginFull === null && data.VisaSEC_UserID === 0
          ? translate('frm_collateral_view-cmd_collateral_visa')
          : translate('frm_collateral_view-cmd_delete_collateral_visa'),
      action: () => {
        const { ID, HashSum_FileID_, VisaLoginFull, VisaSEC_UserID } = data
        let isVisa = true

        if (VisaLoginFull === null && VisaSEC_UserID === 0) {
          isVisa = false
          this.handleToggleFileVisaAction(isVisa, ID, HashSum_FileID_)
        } else {
          this.handleToggleFileVisaAction(isVisa, ID, HashSum_FileID_)
        }
      },
      icon: `${data.VisaLoginFull === null && data.VisaSEC_UserID === 0 ? 'bullet_green' : 'bullet_green_delete'}`,
      permissionKey: 'LFL_VISA',
    },

    {
      name: translateBase('cmd_delete_linkedfile'),
      action: () => {
        const { ID, HashSum_FileID_ } = data

        return this.props
          .deleteFile({
            ID,
            HashSum_FileID_,
            ClientID: this.props.ID,
            HashSum_ClientID_: this.props.hash,
          })
          .then((data) => {
            if (deleteFile.fulfilled.match(data)) {
              this.handleFileUploadSuccess()
            }
          })
      },
      confirmModalConfig: { message: translateLKMessage('MSG_ARE_YOU_SURE') },
      icon: 'delete',
      permissionKey: 'LFL_DELETE',
    },
  ]

  handleOpenFileUpload = () => {
    this.props.openFileUpload({ ClientID: this.props.ID, HashSum_ClientID_: this.props.hash })
  }

  handleFileUploadSuccess = () => {
    this.props.fetchPage(this.props.ID, this.props.hash)
  }

  handleRowDoubleClicked = (props) => {
    const {
      node: {
        data: { ID, HashSum_FileID_: hash, Ext },
      },
    } = props

    if (this.props.CanView && ['jpg', 'pdf'].includes(Ext.toLowerCase())) {
      this.props.openFileDetails({
        ID,
        hash,
        type: Ext,
      })
    }
  }

  handleToggleFileVisaAction = (isVisa: boolean, ID: number, HashSum_FileID_: string) => {
    if (!isVisa) {
      this.props
        .toggleFileVisa({
          ID: ID.toString(),
          HashSum_FileID_,
          ClientID: this.props.ID,
          HashSum_ClientID_: this.props.hash,
        })
        .then((result: {payload: string, type: string, meta: any}) => {
          if (toggleFileVisa.rejected.match(result)) {
            this.props.openError(result.payload)
          } else {
            this.handleFileUploadSuccess()
          }
        })
    } else {
      this.props
        .toggleDeleteFileVisa({
          ID: ID.toString(),
          HashSum_FileID_,
          ClientID: this.props.ID,
          HashSum_ClientID_: this.props.hash,
        })
        .then((result: {payload: string, type: string, meta: any}) => {
          if (toggleDeleteFileVisa.rejected.match(result)) {
            this.props.openError(result.payload)
          } else {
            this.handleFileUploadSuccess()
          }
        })
    }
  }

  render() {
    const { ID, data } = this.props
    return (
      <SegmentGroup>
        <DocumentTitle title={translateBase('lbl_client_view_cap')} />

        <FileUpload onSuccess={this.handleFileUploadSuccess} />

        <Segment.Group>
          <FlexTableChild>
            <TableContainer>
              <LKGrid
                instanceName={`${DCConstants.DetailsGridPrefixes.client}-${ID}-Files`}
                rowData={data}
                {...config}
                onRowDoubleClicked={this.handleRowDoubleClicked}
                getContextMenuItems={this.getContextMenuItems}
              />
            </TableContainer>
          </FlexTableChild>

          {this.props.CanAdd && (
            <Segment>
              <GridContainer>
                <Grid>
                  <Grid.Row columns={1}>
                    <Grid.Column textAlign="right">
                      <LKButton alias="add" size="tiny" onClick={this.handleOpenFileUpload} permission="LFL_ADD">
                        {translateCmd('add_linkedfile')}
                      </LKButton>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </GridContainer>
            </Segment>
          )}
        </Segment.Group>
      </SegmentGroup>
    )
  }
}

//@ts-ignore
Files.config = {
  title: () => translateBase('tb_lfl'),
  name: 'files',
  component: Files,
  api: 'linkedfiles',
  icon: icon('tb_lfl'),
}
//@ts-ignore
Files.defaultProps = {
  data: [],
}

export default Files
